(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rpl-103"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-castle-film]').forEach(function (film) {
  var button = film.querySelector('[data-castle-play]');
  var observer;
  var started = false;
  if (!button) return;
  function startVideo(focusPlayer) {
    if (started) return;
    started = true;
    if (observer) observer.disconnect();
    var player = document.createElement('iframe');
    player.title = 'Discover Republic Wine Castle';
    player.loading = 'lazy';
    player.allow = 'autoplay; encrypted-media; picture-in-picture';
    player.allowFullscreen = true;
    player.src = 'https://www.youtube-nocookie.com/embed/1Qaq9-i10mg?autoplay=1&mute=1&playsinline=1&loop=1&playlist=1Qaq9-i10mg&rel=0';
    button.replaceWith(player);
    if (focusPlayer) player.focus();
  }
  button.addEventListener('click', function () { startVideo(true); }, { once: true });
  function enableAutoplay() {
    if (started || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (navigator.connection && navigator.connection.saveData) return;
    observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) startVideo(false);
    }, { threshold: 0.15 });
    observer.observe(film);
  }
  if (document.readyState === 'complete') enableAutoplay();
  else window.addEventListener('load', enableAutoplay, { once: true });
});

  } catch(e) { console.error(e); }
})();
})();
